import styled from "styled-components";
import { viewSizes } from "./variables";
import Bg from "../images/bg.png";

export const MainWrapper = styled.main`
  background-image: url("${Bg}");
  background-size: cover;
  width: 100vw;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
`;

export const SectionWrapper = styled.section`
  display: flex;
  align-items: center;
  padding: 10rem;
  flex: 1;

  @media only screen and (max-width: ${viewSizes.tablet}) {
  }

  @media only screen and (max-width: ${viewSizes.mobile}) {
    padding: 2rem;
    align-items: flex-start;
    /* margin-top: 10rem; */
  }
`;

export const TitleWrapper = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 70%;
  position: relative;

  & > .titleImg {
    @media only screen and (max-width: ${viewSizes.tablet}) {
    }
  }
  & > .playIcon {
    margin-top: 2rem;
    cursor: pointer;
  }
`;

export const TitleTextWrapper = styled.div`
  display: flex;
  color: white;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > span {
    font-family: "SpoqaHanSansNeo-Light";
    font-size: 4.2rem;

    @media only screen and (max-width: ${viewSizes.mobile}) {
      font-size: 3rem;
    }

    @media only screen and (max-width: 340px) {
      font-size: 2rem;
    }
  }

  & > .english {
    display: flex;

    @media only screen and (max-width: ${viewSizes.mobile}) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    & > span {
      line-height: 1;
      font-size: 15rem;
      font-family: "deadJim";

      @media only screen and (max-width: 1200px) {
        font-size: 12rem;
      }
      @media only screen and (max-width: 1050px) {
        font-size: 11rem;
      }
      @media only screen and (max-width: 800px) {
        font-size: 10rem;
      }

      @media only screen and (max-width: ${viewSizes.mobile}) {
        font-size: 9rem;
      }
    }

    & > span:not(:last-of-type) {
      margin-right: 2.5rem;
    }
  }
`;

export const StoresTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;

  & > p {
    color: #c3c3c3;
    font-size: 1.6rem;
    font-family: "SpoqaHanSansNeo-Regular";
  }
`;

export const StoresWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;

  & > img {
    cursor: pointer;

    @media only screen and (max-width: ${viewSizes.mobile}) {
      width: 33%;
    }
  }
  & > img:not(:last-of-type) {
    margin-right: 1rem;
  }
`;

// naver
export const NaverWrapper = styled.img`
  align-self: baseline;
  top: -10rem;
  position: absolute;
  right: 0;
  cursor: pointer;

  @media only screen and (max-width: ${viewSizes.mobile}) {
    width: 15%;
    top: 0.5rem;
  }

  @media only screen and (max-width: 340px) {
    top: -0.5rem;
  }
`;
